// extracted by mini-css-extract-plugin
export default {"weekDaysLabels":"WeekDays_weekDaysLabels__dvM3N"};